<template>

  <div>
    <el-popover
      v-if="pos.fieldobj.hyperlink"
      :disabled="!dataavailable"
      placement="bottom"
      trigger="hover"
      content="this is content, this is content"
    >
    <div v-if="load">
      <div class="popup" v-for="x in thehyperlink.collections" :key="x">
        <singleclct
          :thedata="datas[x] || []"
          tabletitle=""
          :collection="x"
          :searchval="pos.value"
          :ifheaderoperate="false"
          :iffootermore="false"
        ></singleclct>
      </div>
    </div>
      <el-button
        v-bind:style="{
          position: 'fixed',
          top: pos.y+'px',
          left: pos.x+'px',
          display: pos.display === 'block' ? 'block' : 'none',
        }"
        slot="reference"
        >{{dataavailable?"more":"No data"}}</el-button
      >
    </el-popover>

  </div>
</template>


<script>
import singleclct from "@/components/news/singleclct.vue";
export default {
  props: ["pos"],
  components: { singleclct },
  methods: {},
  data() {
    return {
      load: false,
      datas: {},
      header: [],
    };
  },
  computed: {
    dataavailable() {
      let dataavailable = false;
      this.thehyperlink.collections.forEach((x) => {
        if (this.datas[x] && this.datas[x].doc.length > 0) {
          dataavailable = true;
        }
      });

      return dataavailable;
    },
    thehyperlink() {
      return this.pos.fieldobj.hyperlink;
    },
    thevalue() {
      return this.pos.value;
    },
  },
  watch: {
    thevalue(after, before) {
      this.load = false;
      this.datas = {};
      let thevalue=this.thevalue

      if (this.thehyperlink) {
      //如果指定了eval_value那么eval，可以不指定，默认就为thevalue，如果model为filter，那么必须指定，构造{}
      if(this.thehyperlink.eval_value){
        eval(this.thehyperlink.eval_value)
      }
      
        this.$axios
          .post(url + "aggregateclct", {
            loadingstatus:"none",
            collections: this.thehyperlink.collections,
            model:this.thehyperlink.model,//可以不设置，服务器默认为"generalsearch"，可设置为filter
            value:thevalue,
            thefields: this.thehyperlink.thefields,
          })
          .then((res) => {
            this.load = true;
            // console.log(res.data)
            // let desiredkeys = Object.keys(this.thehyperlink.thefields);
            // for (let obj in res.data) {
            //   let fields = res.data[obj].fields;
            //   fields.forEach((thefield, i) => {
            //     if (!desiredkeys.includes(thefield.name)) {
            //       delete fields[i];
            //     }
            //   });

            //   res.data[obj].fields = res.data[obj].fields.filter(function (el) {
            //     return el != null;
            //   });
            // }

            this.datas = res.data;

            // console.log(this.datas);
            // this.load = true;
          });
      }
    },
  },
};
</script>

<style>
.popup {
  /* position: fixed;
  background-color: rgb(236, 229, 230); */
  /* width: fit-content; */
  max-width: 50vw;
  max-height: 60vh;
  overflow: auto;
}
/* .hyperlink {
  position: fixed;
  background-color: rgb(236, 229, 230);
  max-width: 80vh;
  max-height: 60vh;
  overflow: scroll;
} */
</style>    



// WEBPACK FOOTER //
// src/components/presentation/table/hyperlink.vue